import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {usePendidikanListModel} from "@/stores/models/pendidikan-list-model";

export const usePendidikanListStore  = defineStore(
    'pendidikanListStore',
    () => {
       
        const isLoading = ref(false);
        const selectedPegawai = ref(null);
        const dataSourcePendidikanList = ref(
            new DataSource({
                requireTotalCount: true,
                store: usePendidikanListModel().pendidikanListCustomStore,
                filter: null,
            })
        );

        // const dataSourcePendidikanList = (additionalParams = null) => {
        //     // console.log('masuk dataSourcePendidikanList', additionalParams)
        //     return new DataSource({
        //       requireTotalCount: true,
        //       load: (loadOptions) => {
        //         // Handle load options and additionalParams separately
        //         return usePendidikanListModel().pendidikanListCustomStore.load([loadOptions, additionalParams]);
        //       }
        //     });
        // };

         const getData = async (filter, sort=null) => {
            usePendidikanListModel().setFilter(filter);
            usePendidikanListModel().setSort(sort);
            usePendidikanListModel().setTake('all');
                             await  dataSourcePendidikanList.value.reload();
                
                            //  const totalBiaya = _.sumBy(dataSourceDiklatList.value.items(), 'biaya');
                            
                             return {
                                data: dataSourcePendidikanList.value._items,
                                totalCount: dataSourcePendidikanList.value._items.length,
                                // summary: [totalBiaya]
                            };
                
                            //  return dataSourceDiklatList.value._items;
                }

        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourcePendidikanList.value.reload();
        };

        const initialized = ()=>{     
            usePendidikanListModel().setFilter(null);
            dataSourcePendidikanList.value.reload();
        };

        return {
            dataSourcePendidikanList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state,
            selectedPegawai,
            getData

        }
    }
);